import { Injectable } from '@angular/core';
import { BaseApi } from '@core/classes/base-api.class';
import { BazaKomentiForCreationDTO } from '@core/interfaces/dto/baza-komenti-for-creation-dto.inteface';
import { BazaKomentiForUpdateDTO } from '@core/interfaces/dto/baza-komenti-for-update-dto.interface';
import { BazaKomentiParamsDTO } from '@core/interfaces/dto/baza-komenti-params-dto.interface';
import { BazaKomenti } from '@core/interfaces/models/baza-komenti.interface';
import { ApiService } from './api.service';

@Injectable({
  providedIn: 'root'
})
export class BazaKomentiService extends BaseApi<BazaKomenti, BazaKomentiParamsDTO, BazaKomentiForCreationDTO, BazaKomentiForUpdateDTO> {
  constructor(apiService: ApiService) {
    super(apiService, 'bazaKomenti/');
  }
}